export default __webpack_public_path__ + "locales/nl/SocialAuthWelcomeDialog.json?hash=cbd80bee598cd7cca8161ac6651c3840";